module.exports = __webpack_public_path__ + "static/media/changeMind.86f1f1bf.mp3";